import { defineMessages } from 'react-intl'

export const cancelSubscriptionMessages = defineMessages({
  ctaBtn: {
    id: 'cancelSubscription.ctaBtn',
    description:
      'CTA button text on modal asking to Cancel/Downgrade subscription',
    defaultMessage: 'Yes, Cancel',
  },
  cancelBtn: {
    id: 'cancelSubscription.cancelBtn',
    description:
      'Cancel button text on modal asking to cancel all subscriptions',
    defaultMessage: 'No, Keep',
  },
  title: {
    id: 'cancelSubscription.title',
    description:
      'A title of modal when user tries to cancel/downgrade subscription',
    defaultMessage: 'Cancel all subscriptions?',
  },
  confirmText: {
    id: 'cancelSubscription.confirmText',
    description:
      'Modal confirm text for canceling/downgrade of active subscription',
    defaultMessage:
      '<b>All</b> subscriptions will end on date {planEndDate}{br}After this date this home will have basic features.{br}{br}Are you sure you want to cancel this subscription now?',
  },
})
